import { Badge } from '../../components/Badge'
import { Card } from '../../components/Card'
import { Link, LinkProps } from '../../components/Link'
import { genderLabelMap, levelLabelMap } from '../../constants/index'
import { formatNumber } from '../../utils/formatNumber'

export interface ProgramCardProps {
  name: string
  image: string
  duration: number
  minimumPoint?: number | null
  minTimetablePoint?: number
  maxTimetablePoint?: number
  activities: string[] | { name: string }[]
  level: 1 | 2 | 3 | 4
  sexLimitation?: 'none' | 'men' | 'women'
  href?: LinkProps['href']
  external?: LinkProps['external']
  target?: LinkProps['target']
  as?: LinkProps['as']
  priority?: boolean
}

export const ProgramCard = ({
  name,
  image,
  duration,
  minimumPoint,
  minTimetablePoint,
  maxTimetablePoint,
  activities,
  level,
  sexLimitation,
  href,
  as,
  external,
  target,
  priority,
}: ProgramCardProps) => {
  const images = [
    {
      src: image,
      alt: `${name}の画像`,
    },
  ]

  const point = minimumPoint
    ? formatNumber(minimumPoint) + 'pt〜'
    : minTimetablePoint === maxTimetablePoint
    ? formatNumber(minTimetablePoint ?? 0) + 'pt'
    : formatNumber(minTimetablePoint ?? 0) + 'pt〜'

  const hasPoint = minimumPoint || minTimetablePoint || maxTimetablePoint

  const firstActivity = activities[0]
    ? typeof activities[0] === 'string'
      ? activities[0]
      : activities[0].name
    : null

  const card = (
    <Card layout="horizontal" variant="secondary">
      <Card.Image images={images} priority={priority} />

      <Card.Content>
        <Card.Content.Heading>{name}</Card.Content.Heading>

        <Card.Content.Body>
          {duration}min{hasPoint ? `/ ${point}` : ''}
        </Card.Content.Body>

        <Card.Content.BadgeList mt="auto">
          {firstActivity && <Badge>{firstActivity}</Badge>}
          <Badge>{levelLabelMap[level]}</Badge>
          {sexLimitation && sexLimitation !== 'none' && (
            <Badge variant={sexLimitation}>
              {genderLabelMap[sexLimitation]}
            </Badge>
          )}
        </Card.Content.BadgeList>
      </Card.Content>
    </Card>
  )

  return href ? (
    <Link href={href} as={as} external={external} target={target}>
      {card}
    </Link>
  ) : (
    card
  )
}
